@import '../../global/style/all-tenants/custom-properties/components-properties/dynamic-teaser';

:host {
  display: block;
  margin-bottom: var(--cms-components-mb);
  @include cms-base-font-100;
}

.error-container {
  grid-area: var(--cms-grid-item-area);
}

.error-list {
  margin: 0;
  padding: 0 0 0 var(--cms-spacing-075);
}

.error-item {
  color: var(--cms-semanticColors-error-text);
}

.teaser-list-container-inner {
  @include cms-default-grid-container;
}

.teaser-headline {
  max-width: var(--cms-container-max-width);
  font-family: var(--cms-font-badhouse);
  font-weight: var(--cms-heading-base-font-weight);
  line-height: var(--cms-heading-base-line-height);
  margin-bottom: var(--cms-heading-base-margin-bottom);
  margin-top: var(--cms-heading-base-margin-top);
  margin-left: auto;
  margin-right: auto;
  color: var(--cms-theme-text-color);
  font-size: var(--cms-heading-rfs-h2);
  padding: 0 var(--cms-spacing-100);
}

.badge-wrapper {
  @include dynamic-teaser-badge
}

.scratch svg path {
  fill: var(--cms-semanticColors-base-medium-background);
}

@include media-width($breakpoint-sm) {
  .teaser-container.grid-item:nth-child(1):nth-last-child(1) {
    --cms-default-grid-area: auto / 5 / auto / span 4;
  }

  .teaser-container.grid-item:nth-child(1):nth-last-child(2) {
    --cms-default-grid-area: auto / auto / auto / span 6;
  }
}

@include media-width($breakpoint-md) {
  .teaser-container.grid-item:nth-child(1):nth-last-child(2) {
    --cms-default-grid-area: auto / 3 / auto / span 4;
  }
}